export default __webpack_public_path__ + "static/media/three_green.eac1dce2.svg";